var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomBlue = function SvgCustomBlue(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1919_94289)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.55556 15.5L2.55556 10.8333M2.55556 10.8333C3.41467 10.8333 4.11111 10.1369 4.11111 9.27778C4.11111 8.41867 3.41467 7.72222 2.55556 7.72222C1.69645 7.72222 1 8.41867 1 9.27778C1 10.1369 1.69645 10.8333 2.55556 10.8333ZM2.55556 4.61111V1.5M8 15.5V10.8333M8 4.61111V1.5M8 4.61111C7.14089 4.61111 6.44444 5.30756 6.44444 6.16667C6.44444 7.02578 7.14089 7.72222 8 7.72222C8.85911 7.72222 9.55556 7.02578 9.55556 6.16667C9.55556 5.30756 8.85911 4.61111 8 4.61111ZM13.4444 15.5V12.3889M13.4444 12.3889C14.3036 12.3889 15 11.6924 15 10.8333C15 9.97422 14.3036 9.27778 13.4444 9.27778C12.5853 9.27778 11.8889 9.97422 11.8889 10.8333C11.8889 11.6924 12.5853 12.3889 13.4444 12.3889ZM13.4444 6.16667V1.5",
    stroke: "#5547DD",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1919_94289"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomBlue);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "CustomBlue.63d155c770e2ea2120af186b4559cf8f.svg";